import React, { useEffect, useState } from "react";
import Footer from "./Footer";
import { useNavigate, Link, useParams } from 'react-router-dom';



// import "./portfolio.css";

function Aboutus() {

  useEffect(() => {
    // ----- MENU TOGGLE -----
    const menuToggle = document.getElementById("menuToggle");
    const navLinks = document.getElementById("navLinks");

    if (menuToggle && navLinks) {
      const handleMenuClick = () => {
        menuToggle.classList.toggle("active");
        navLinks.classList.toggle("show");
      };

      menuToggle.addEventListener("click", handleMenuClick);

      // cleanup
      return () => {
        menuToggle.removeEventListener("click", handleMenuClick);
      };
    }
  }, []);

  useEffect(() => {
    // ----- TEAM SLIDER -----
    const slider = document.querySelector(".team-slider");
    const track = document.querySelector(".team-track");
    const nextBtn = document.querySelector(".team-arrow.next");
    const prevBtn = document.querySelector(".team-arrow.prev");
    const cards = Array.from(document.querySelectorAll(".team-card"));

    if (!slider || !track || !nextBtn || !prevBtn || !cards.length) return;

    let scrollX = 0;

    const cardStep = () => {
      if (!cards.length) return 0;
      const style = getComputedStyle(track);
      const gap = parseFloat(style.columnGap || style.gap || 0);
      return cards[0].offsetWidth + gap;
    };

    const maxScroll = () =>
      Math.max(0, track.scrollWidth - slider.clientWidth - 1);

    const moveSlider = (delta) => {
      scrollX = Math.min(Math.max(0, scrollX + delta), maxScroll());
      track.style.transform = `translateX(-${scrollX}px)`;
      prevBtn.classList.toggle("is-disabled", scrollX <= 0);
      nextBtn.classList.toggle("is-disabled", scrollX >= maxScroll());
    };

    const scrollNext = () => moveSlider(cardStep());
    const scrollPrev = () => moveSlider(-cardStep());
    const handleResize = () => moveSlider(0);

    nextBtn.addEventListener("click", scrollNext);
    prevBtn.addEventListener("click", scrollPrev);
    window.addEventListener("resize", handleResize);

    // initialize position
    moveSlider(0);

    // cleanup on unmount
    return () => {
      nextBtn.removeEventListener("click", scrollNext);
      prevBtn.removeEventListener("click", scrollPrev);
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <>


      <header class="top-4 z-40 " style={{ marginTop: "10px" }}>
        <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div
            class="bg-white/90 backdrop-blur ring-1 ring-black/5 rounded-[20px] md:rounded-[28px] px-3 sm:px-4 md:px-6">

            <div class="flex items-center justify-between h-12">
              <a href="#" class="flex items-center gap-2">
                <img src="assets/youvati_logo.png" alt="Youvati" class="w-auto" style={{ height: "2rem" }} />
              </a>


              <nav class="hidden md:flex items-center  text-sm" style={{ gap: "2.2rem", fontWeight: "600" }}>
                <Link to="/" class="hover:text-[#7872F8] ">Home</Link>
                {/* <Link to="" class="hover:text-[#7872F8]">Partner with us</Link> */}
                <Link to="/aboutus" class="text-[#7872F8] px-2 py-0.5 rounded-lg bg-[#F0EFFE]">About us</Link>
                <Link to="/contactus" class="hover:text-[#7872F8]">Contact us</Link>
              </nav>


              <a href="https://play.google.com/store/apps/details?id=com.empower.youvati&hl=en_IN"
                target="_blank">
                <div class="hidden md:flex items-center gap-2 rounded-xl border px-2.5 py-0.5 shadow-sm">
                  <span class="font-bold text-sm">Download App</span>
                  <img src="assets/arrow.png" alt="qr" class="h-6 w-6" />
                </div>
              </a>


              <button id="menuBtn"
                class="md:hidden inline-flex items-center justify-center rounded-xl border px-2 py-1"
                aria-controls="mobileMenu" aria-expanded="false" aria-label="Open Menu">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"
                  class="w-5 h-5">
                  <path fill-rule="evenodd"
                    d="M3.75 5.25a.75.75 0 01.75-.75h15a.75.75 0 010 1.5h-15a.75.75 0 01-.75-.75zm0 6a.75.75 0 01.75-.75h15a.75.75 0 010 1.5h-15a.75.75 0 01-.75-.75zm0 6a.75.75 0 01.75-.75h15a.75.75 0 010 1.5h-15a.75.75 0 01-.75-.75z"
                    clip-rule="evenodd" />
                </svg>
              </button>
            </div>


            <div id="mobileMenu" class="md:hidden hidden border-t border-black/5 pt-3 pb-3">
              <nav class="flex flex-col gap-3 text-sm" style={{ fontWeight: "600" }}>
                <a class="text-[#7872F8] px-2 py-1 rounded-lg bg-[#F0EFFE] w-max" href="#home">Home</a>
                <a class="hover:text-[#7872F8]" href="#partners">Partner with us</a>
                <a class="hover:text-[#7872F8]" href="#about">About us</a>
                <a class="hover:text-[#7872F8]" href="#contact">Contact us</a>
                <a class="inline-flex items-center gap-2 rounded-xl border px-3 py-2 w-max"
                  href="https://play.google.com/store/apps/details?id=com.empower.youvati&hl=en_IN">
                  <span class="font-bold">Download App</span>
                  <img src="assets/arrow.png" class="h-6 w-6" />
                </a>
              </nav>
            </div>
          </div>
        </div>
      </header>

      <section id="hero">
        <div class="container">
          <div class="hero-content">
            <div class="hero-text">
              <h1>We At Youvati
                <h1>Are<span class="highlight"> Crafting</span>
                  <br />
                  <span class="highlight">Excellence</span> <span class="">Together</span>
                </h1>
              </h1>
            </div>
            <div class="hero-stats-card">
              <div class="hero-stats-image-wrapper">
                <img src="assets/rimage.png" alt="Team Collaboration" />
                <div class="hero-stats-text-content">
                  {/* <p class="hero-stats-number">16k<span class="hero-stats-plus-icon">+</span></p>
                  <p class="hero-stats-label">App Downloads</p> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section id="about">
        <div class="container">
          <div class="about-content">
            <div class="about-visuals">
              <div class="about-image-wrapper">
                <img src="assets/statsframe.png" alt="Team hands together" />
              </div>
            </div>
            <div class="about-text">
              <h2>About The <span class="highlight">Team</span></h2>
              <p>
                The Youvati team is a dynamic group from diverse backgrounds across India, united by a shared commitment to
                innovating methods for maximizing social impact. They bring together expertise in:
              </p>
              <div class="expertise-grid">
                <div class="expertise-item">
                  <div class="expertise-icon-bg">
                    <img src="assets/1625_329.svg" alt="Book" />
                  </div>
                  <span>Sector Knowledge</span>
                </div>
                <div class="expertise-item">
                  <div class="expertise-icon-bg">
                    <img src="assets/1625_333.svg" alt="Code" />
                  </div>
                  <span>Technical Expertise</span>
                </div>
                <div class="expertise-item">
                  <div class="expertise-icon-bg">
                    <img src="assets/1625_336.svg" alt="Design" />
                  </div>
                  <span>Design Expertise</span>
                </div>
                <div class="expertise-item">
                  <div class="expertise-icon-bg">
                    <img src="assets/1625_340.svg" alt="Discussion" />
                  </div>team-header
                  <span>Outreach Capabilities</span>
                </div>
              </div>
              <p>
                This unique blend positions them to build Youvati into a transformative platform for women
                micro-entrepreneurs.
              </p>
            </div>
          </div>
        </div>
      </section>


      {/* <section id="team" style={{ padding: "0px 0" }}>
        <div class="container">
          <div class="team-header"
            style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "40px" }}>
            <h2
              style={{ fontFamily: "var(--font-secondary)", fontSize: "clamp(28px, 4vw, 40px)", fontWeight: "700", color: "var(--color-text-primary)" }}>
              Meet Our <span class="highlight">Team</span>
            </h2>
            <div class="team-arrows">
              <button class="team-arrow prev">&#10094;</button>
              <button class="team-arrow next" style={{ background: "var(--color-primary)", color: "white" }}>&#10095;</button>
            </div>
          </div>

          <div class="team-slider">
            <div class="team-track">

              <div class="team-card">
                <div class="team-img-wrapper">
                  <img class="timelines" src="https://images.pexels.com/photos/31850145/pexels-photo-31850145.jpeg" alt="Alicia Keys" />
                  <div class="linkedin-badge">in</div>
                </div>
                <div class="team-info">
                  <h4>Alicia Keys</h4>
                  <p>Founder & CEO</p>
                </div>
              </div>


              <div class="team-card">
                <div class="team-img-wrapper">
                  <img class="timelines" src="https://images.pexels.com/photos/19503032/pexels-photo-19503032.jpeg" alt="Daniela Lopez" />
                  <div class="linkedin-badge">in</div>
                </div>
                <div class="team-info">
                  <h4>Daniela Lopez</h4>
                  <p>Marketing Manager</p>
                </div>
              </div>


              <div class="team-card">
                <div class="team-img-wrapper">
                  <img class="timelines" src="https://images.pexels.com/photos/31906799/pexels-photo-31906799.jpeg" alt="John Smith" />
                  <div class="linkedin-badge">in</div>
                </div>
                <div class="team-info">
                  <h4>John Smith</h4>
                  <p>Design Lead</p>
                </div>
              </div>

              <div class="team-card">
                <div class="team-img-wrapper">
                  <img class="timelines" src="https://images.pexels.com/photos/31906799/pexels-photo-31906799.jpeg" alt="Anya Sharma" />
                  <div class="linkedin-badge">in</div>
                </div>
                <div class="team-info">
                  <h4>Anya Sharma</h4>
                  <p>Tech Lead</p>
                </div>
              </div>
              <div class="team-card">
                <div class="team-img-wrapper">
                  <img class="timelines" src="https://images.pexels.com/photos/31906799/pexels-photo-31906799.jpeg" alt="Anya Sharma" />
                  <div class="linkedin-badge">in</div>
                </div>
                <div class="team-info">
                  <h4>Anya Sharma</h4>
                  <p>Tech Lead</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section> */}


      <section id="work-with-us" style={{ padding: "80px 0" }}>
        <div class="container work-container">
          <div class="work-left">
            <h2 class="work-heading">
              <span class="highlight">Work</span> With Us
            </h2>
            <p class="work-text">
              If you are driven to create change and ready to shape the future of women-led businesses,
              we’d love to have you on this journey.
            </p>
          </div>

          <div class="work-right">
            <div class="work-card">
              <img src="assets/9b5e8f21f005359ad811fecec0fe601a32041640.png" alt="Work With Us" />
              <div class="work-overlay">
                <p>Send your updated resume at</p>
                <a href="mailto:recruitment@youvati.com" class="work-btn">
                  recruitment@youvati.com
                  {/* <div className="icon-wrapper"> */}
                  <img src="assets/arrow2.png" style={{ height: "28px" }} alt="arrow" />
                  {/* </div> */}
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>



      <section id="journey-desktop" class="journey" style={{ background: "white", padding: "11px" }}>
        <div class="container">
          <h2 class="journey-title" style={{ fontSize: "clamp(28px, 4vw, 40px)", fontWeight: "700" }}>Our <span class="highlight">Journey</span></h2>

          <div class="timeline-container">
            <div class="timeline-line"></div>

            <ul class="timeline">
              <li data-year="2022" data-text="Launched as Beauty Super-App under Empower Pragati | Pilot with 200 trainees">
              </li>
              <li data-year="2023" data-text="Expansion events | Partnered with Samhita CGF | Introduced skill workshops">
              </li>
              <li data-year="2024"
                data-text="Partnered with SIDBI | Reached 10K+ users | Expanded to women micro-entrepreneurs in multiple domains">
              </li>
              <li data-year="2025"
                data-text="Launched Youvati 2.0 | Incorporated as Able Edutech Pvt. Ltd. | Partnered with NASSCOM Foundation | Serving 16K+ users in 850+ cities">
              </li>
            </ul>


          </div>
        </div>
      </section>










      <section id="journey-mobile" class="journeym">
        <div class="container">
          <h2 class="journeym-title">Our <span class="highlight">Journey</span></h2>

          <div class="timeline-containerm">
            <ul class="timeline-verticalm">
              <li>
                <div class="content">
                  <h3>2022</h3>
                  <p>Launched as Beauty Super-App under Empower Pragati | Pilot with 200 trainees</p>
                </div>
              </li>

              <li>
                <div class="content">
                  <h3>2023</h3>
                  <p>Expansion events | Partnered with Samhita CGF | Introduced skill workshops</p>
                </div>
              </li>

              <li>
                <div class="content">
                  <h3>2024</h3>
                  <p>Partnered with SIDBI | Reached 10K+ users | Expanded to women micro-entrepreneurs in multiple domains
                  </p>
                </div>
              </li>

              <li>
                <div class="content">
                  <h3>2025</h3>
                  <p>Launched Youvati 2.0 | Incorporated as Able Edutech Pvt. Ltd. | Partnered with NASSCOM Foundation |
                    Serving 16K+ users in 850+ cities</p>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </section>



      <Footer />

      <style>{`
    :root {
      --color-primary: #938EFA;
      --color-accent: #F3A5BF;
      --color-primary-bg: #F6F5FA;
      --color-primary-bg-light: #F1EEFE;
      --color-background: #ffffff;
      --color-text-primary: #222222;
      --color-text-secondary: #555555;
      --color-white: #ffffff;
      --font-primary: 'Montserrat', sans-serif;
      --font-secondary: 'Syne', sans-serif;

      /* fluid sizes */
      --space-xs: clamp(6px, 0.7vw, 10px);
      --space-sm: clamp(10px, 1.2vw, 14px);
      --space-md: clamp(16px, 1.8vw, 22px);
      --space-lg: clamp(24px, 2.6vw, 36px);
      --space-xl: clamp(36px, 4vw, 64px);

      --radius-xl: 32px;
    }

    /* Base */
    * {
      box-sizing: border-box
    }

    

    body {
      margin: 0;
      font-family: var(--font-primary);
      background: #F6F5FA;
      color: var(--color-text-primary);
      line-height: 1.55;
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
    }

    img {
      max-width: 100%;
      height: auto;
      display: block
    }

    .container {
      width: 100%;
      max-width: min(1200px, 92vw);
      margin: 0 auto;
      padding: 0 var(--space-md);
    }

    .timelines{
    --r: 41px;
    --s: 50px;
    --x: -2px;
    --y: 15px;
    border-radius: var(--r);
    --_m: /calc(2*var(--r)) calc(2*var(--r)) radial-gradient(#000 70%,#0000 72%);
    --_g: conic-gradient(at calc(100% - var(--r)) var(--r), #0000 24%, #000 0);
    --_d: (var(--s) + var(--r));
    mask: calc(100% - var(--_d) - var(--x)) 0 var(--_m), 100% calc(var(--_d) + var(--y)) var(--_m), radial-gradient(var(--s) at 100% 0, #0000 99%, #000 calc(100% + 1px)) calc(-1 * var(--r) - var(--x)) calc(var(--r) + var(--y)), var(--_g) calc(-1 * var(--_d) - var(--x)) 0, var(--_g) 0 calc(var(--_d) + var(--y));
    mask-repeat: no-repeat;}



    .logo-container {
      width: 92px;
      display: flex;
      align-items: center;
      justify-content: center
    }

    .nav-links {
      display: flex;
      gap: 28px;
      list-style: none;
      margin: 0;
      padding: 0;
      align-items: center;
    }

    .nav-links a {
      text-decoration: none;
      font-weight: 500;
      color: var(--color-text-secondary);
      padding: 6px 12px;
      border-radius: 8px;
      transition: .25s ease;
    }

    .nav-links a:hover,
    .nav-links a.active {
      color: var(--color-primary);
      background: var(--color-primary-bg-light);
    }

    .btn-download {
      display: flex;
      align-items: center;
      gap: 8px;
      border: 1px solid var(--color-text-primary);
      border-radius: 20px;
      padding: 6px 12px;
      font-weight: 500;
      text-decoration: none;
      color: var(--color-text-primary);
      transition: .25s ease;
      white-space: nowrap;
    }

    .btn-download:hover {
      background: var(--color-text-primary);
      color: var(--color-white)
    }

    .btn-icon-wrapper {
      background: var(--color-text-primary);
      width: 28px;
      height: 28px;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 50%;
    }

    .btn-download:hover .btn-icon-wrapper {
      background: var(--color-white)
    }

    /* Hamburger */
    .menu-toggle {
      display: none;
      width: 32px;
      height: 26px;
      cursor: pointer;
      gap: 5px;
      flex-direction: column;
      justify-content: center
    }

    .menu-toggle span {
      display: block;
      height: 3px;
      background: var(--color-text-primary);
      border-radius: 2px;
      transition: .25s
    }

    .menu-toggle.active span:nth-child(1) {
      transform: translateY(8px) rotate(45deg)
    }

    .menu-toggle.active span:nth-child(2) {
      opacity: 0
    }

    .menu-toggle.active span:nth-child(3) {
      transform: translateY(-8px) rotate(-45deg)
    }

    /* MOBILE NAV */
    @media (max-width: 992px) {
      .menu-toggle {
        display: flex
      }

      .btn-download {
        display: none
      }

      .nav-links {
        display: none;
        position: absolute;
        left: var(--space-md);
        right: var(--space-md);
        top: calc(100% + 8px);
        /* opens BELOW the bar */
        background: var(--color-white);
        flex-direction: column;
        padding: var(--space-sm);
        border-radius: 16px;
        box-shadow: 0 12px 30px rgba(0, 0, 0, .08);
        overflow: hidden;
      }

      .nav-links.show {
        display: flex
      }

      .nav-links li {
        width: 100%
      }

      .nav-links a {
        display: block;
        padding: 12px;
        border-radius: 12px
      }
    }

    /* HERO */
    #hero {
      padding: var(--space-xl) 0 var(--space-lg);
      margin-bottom: 4rem;
    }

    .hero-content {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: var(--space-lg);
      flex-wrap: wrap;
    }

    .hero-text {
      flex: 1 1 115px
    }

    .hero-text h1 {
      font-family: var(--font-secondary);
      font-size: clamp(28px, 5.2vw, 46px);
      font-weight: 700;
      line-height: 1.1;
      margin: 0;
    }

    .highlight {
      color: var(--color-primary)
    }

    /* Stats card – fluid */
    .hero-stats-card {
      position: relative;
      flex: 1 1 100px;
      max-width: 640px;
      width: 100%;
      aspect-ratio: 3 / 1;
      /* keeps the rounded “pill” */
      border-radius: 100px;
      overflow: hidden;
      display: flex;
      align-items: center;
      justify-content: center;
      isolation: isolate;
    }

    .hero-stats-image-wrapper {
      position: absolute;
      inset: 0
    }

    .hero-stats-image-wrapper img {
      width: 100%;
      /* height: 100%; */
      object-fit: cover
    }

    .hero-stats-text-content {
      position: absolute;
      inset: auto;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      color: var(--color-white);
      text-align: center;
      padding: 0 var(--space-sm);
    }

    .hero-stats-number {
      font-family: var(--font-secondary);
      font-size: clamp(36px, 7vw, 72px);
      margin: 0;
    }

    .hero-stats-plus-icon {
      background: var(--color-accent);
      border-radius: 50%;
      font-size: 18px;
      padding: 4px 8px;
      margin-left: 6px
    }

    .hero-stats-label {
      font-size: clamp(14px, 2.8vw, 20px);
      margin-top: 4px
    }

    /* ABOUT */
    #about {
      padding: var(--space-xl) 0;
      /* background: var(--color-primary-bg) */
    }

    .about-content {
      display: flex;
      align-items: center;
      gap: var(--space-xl);
      flex-wrap: wrap;
    }

    .about-visuals {
      flex: 1 1 360px;
      position: relative;
      min-width: 280px
    }

    .about-image-wrapper {
      border-radius: 28px;
      overflow: hidden
    }

    .about-image-wrapper img {
      width: 100%;
      height: auto;
      object-fit: cover
    }

    .about-text {
      flex: 1 1 380px;
      min-width: 280px
    }

    .about-text h2 {
      font-family: var(--font-secondary);
      font-size: clamp(24px, 3.8vw, 42px);
      font-weight: 700;
      margin: 0 0 var(--space-sm);
    }

    .about-text p {
      color: var(--color-text-secondary);
      font-size: clamp(14px, 1.7vw, 18px);
      margin: 0 0 var(--space-md)
    }

    .expertise-grid {
      display: grid;
      grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
      gap: var(--space-md);
      margin: var(--space-md) 0;
    }

    .expertise-item {
      display: flex;
      align-items: center;
      gap: 14px
    }

    .expertise-icon-bg {
      width: 50px;
      height: 50px;
      min-width: 50px;
      background: var(--color-primary-bg-light);
      border-radius: 12px;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .expertise-item span {
      font-weight: 500;
      color: var(--color-text-secondary)
    }

    /* Narrow screens */
    @media (max-width: 768px) {
      .hero-content {
        flex-direction: column;
        text-align: center
      }

      .about-content {
        flex-direction: column;
        text-align: left
      }

      .expertise-item {
        justify-content: flex-start
      }

      .header-section {
        padding: 10px 0
      }
    }

    @media (max-width: 480px) {
      .main-nav {
        padding: 6px 12px
      }

      .logo-container {
        width: 84px
      }

      .hero-stats-card {
        border-radius: 64px
      }

      .about-image-wrapper {
        border-radius: 22px
      }
    }



    /* ==============================Team css++++++++++++++++++++++++++++++++ */
    .team-slider {
      overflow: hidden;
      position: relative;
      padding-right: 2px;
      /* tiny buffer avoids fractional cutoff */
    }

    .team-track {
      display: flex;
      gap: 20px;
      transition: transform 0.4s ease;
      will-change: transform;
    }


    .team-card {
      flex: 0 0 clamp(260px, 25vw, 320px);
      /* background: #fff; */
      border-radius: 24px;
      overflow: hidden;
      /* ensures clean corner cut */
      /* box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05); */
      position: relative;
    }

    .team-img-wrapper {
      position: relative;
      height: 340px;
      overflow: hidden;
      border-radius: 24px;
      /* keeps card’s curve visible */
    }

    .team-img-wrapper img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      border-top-right-radius: 24px;
      /* key line */
      border-top-left-radius: 24px;
    }

    /* --- LinkedIn badge inside top-right curve --- */
    .linkedin-badge {
      position: absolute;
      top: 0;
      right: 0;
      width: 76px;
      height: 82px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: var(--color-primary-bg-light);
      color: var(--color-primary);
      font-weight: 700;
      font-size: 18px;
      font-family: var(--font-secondary);
      border-radius: 26px;
      /* box-shadow: 0 4px 10px rgba(0, 0, 0, 0.08); */
      z-index: 2;
      transition: all 0.25s ease;
    }



    /* Info text */
    .team-info {
      position: absolute;
      bottom: 16px;
      left: 16px;
      color: white;
      text-shadow: 0 2px 4px rgba(0, 0, 0, 0.4);
    }

    .team-info h4 {
      margin: 0;
      font-weight: 600;
    }

    .team-info p {
      margin: 4px 0 0;
      font-size: 14px;
    }


    /* Optional disabled style */
    .team-arrow.is-disabled {
      opacity: 0.5;
      pointer-events: none;
    }

    .team-arrow {
      width: 38px;
      height: 38px;
      border-radius: 50%;
      border: 1px solid #ccc;
      background: #fff;
      font-size: 18px;
      cursor: pointer;
      transition: 0.3s;
      margin-left: 6px;
    }

    .team-arrow:hover {
      background: var(--color-primary);
      color: white;
    }

    /* Responsive tweaks */
    @media (max-width: 768px) {
      .team-track {
        gap: 16px;
      }

      .team-card {
        /* flex: 0 0 240px;
         */
        flex: 0 0 clamp(240px, 26vw, 320px);
      }

      .team-img-wrapper {
        height: 300px;
      }

      .team-header {
        flex-direction: column;
        align-items: flex-start;
        gap: 16px;
      }
    }

    @media (max-width: 480px) {
      .team-card {
        flex: 0 0 85%;
        margin: 0 auto;
      }

      .team-img-wrapper {
        height: 280px;
      }

      .team-arrows {
        align-self: flex-end;
      }
    }



    /* ================================End of Team css+++++++++++++++++++++++++++++ */



    /* =======================================work section css+++++++++++++++++++++++++ */



    /* Work With Us Section */
    .work-container {
      display: flex;
      justify-content: space-between;
      align-items: center;
      flex-wrap: wrap;
      gap: 40px;
    }

    .work-left {
      flex: 1 1 400px;
    }

    .work-heading {
      font-family: var(--font-secondary);
      font-size: clamp(28px, 4vw, 40px);
      font-weight: 700;
      color: var(--color-text-primary);
      margin-bottom: 20px;
    }

    .work-heading .highlight {
      color: var(--color-primary);
    }

    .work-text {
      color: var(--color-text-secondary);
      font-size: 18px;
      max-width: 480px;
      line-height: 1.6;
    }

    .work-right {
      flex: 1 1 420px;
      display: flex;
      justify-content: center;
    }

    .work-card {
      position: relative;
      border-radius: 20px;
      overflow: hidden;
      box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);
      max-width: 420px;
    }

    .work-card img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      display: block;
    }

    .work-overlay {
      position: absolute;
      inset: 0;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      background: rgba(0, 0, 0, 0.45);
      text-align: center;
      padding: 20px;
    }

    .work-overlay p {
      color: #fff;
      font-size: 16px;
      margin-bottom: 10px;
      font-weight: 500;
    }

    .work-btn {
      display: inline-flex;
      align-items: center;
      gap: 10px;
      background: var(--color-primary);
      color: #fff;
      font-weight: 600;
      font-size: 15px;
      text-decoration: none;
      padding: 10px 20px;
      border-radius: 30px;
      transition: all 0.3s ease;
    }

    .work-btn:hover {
      background: var(--color-accent);
    }

    .work-icon {
      font-size: 18px;
      transform: rotate(-45deg);
    }

    /* Responsive */
    @media (max-width: 992px) {
      .work-container {
        flex-direction: column;
        text-align: center;
      }

      .work-left,
      .work-right {
        flex: 1 1 100%;
      }

      .work-text {
        margin: 0 auto;
      }

      .work-card {
        max-width: 90%;
      }
    }



    /* ======================end of work section css+++++++++++++++++++++++++  */



    /* ====================== Journey Section ======================================= */




    /* base reset kept */
    .timeline {
      position: relative;
      display: flex;
      justify-content: space-between;
      align-items: center;
      gap: clamp(24px, 6vw, 140px);
      list-style: none;
      width: 100%;
      max-width: 1200px;
      margin: 80px auto;
      padding: 160px 108px;
      /* space above/below the line */
    }

    /* horizontal center line */
    .timeline::after {
      content: "";
      position: absolute;
      left: 24px;
      right: 24px;
      top: 50%;
      transform: translateY(-50%);
      height: 2px;
      background: rgba(147, 142, 250, 0.3);
      z-index: 0;
    }

    /* marker */
    .timeline li {
      position: relative;
      width: 28px;
      height: 28px;
      border-radius: 50%;
      z-index: 1;
      /* outer halo + ring */
      box-shadow: 0 0 0 10px #F6F5FA;
      border: 3px solid #938EFA;
      /* gradient fill */
      background: radial-gradient(circle at 40% 35%, #6f67f7 0%, #453fe0 70%);
    }

    /* YEAR label */
    .timeline li::before {
      content: attr(data-year);
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      font-family: 'Syne', sans-serif;
      font-weight: 700;
      color: #938EFA;
      font-size: 20px;
      letter-spacing: .2px;
      white-space: nowrap;
    }

    /* DESCRIPTION */
    .timeline li::after {
      content: attr(data-text);
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      width: min(260px, 28vw);
      text-align: center;
      font-family: 'Montserrat', sans-serif;
      font-size: 16px;
      line-height: 1.6;
      color: #555;
    }

    /* Alternate positions — EXACTLY like your reference */
    .timeline li:nth-child(odd)::after {
      /* 1st, 3rd… text ABOVE line */
      bottom: calc(50% + 58px);
      /* 40px gap above line + badge size */
    }

    .timeline li:nth-child(odd)::before {
      /* year BELOW line */
      top: calc(50% + 40px);
    }

    .timeline li:nth-child(even)::before {
      /* year ABOVE line */
      bottom: calc(50% + 40px);
    }

    .timeline li:nth-child(even)::after {
      /* text BELOW line */
      top: calc(50% + 58px);
    }




    :root {
      --color-primary: #938EFA;
      --color-bg: #F6F5FA;
    }

    /* ===== Container ===== */
    #journeym {
      background: var(--color-bg);
      padding: 80px 20px;
      font-family: 'Montserrat', sans-serif;
    }

    .journeym-title {
      text-align: center;
      font-family: 'Syne', sans-serif;
      font-size: 36px;
      font-weight: 700;
      margin-bottom: 60px;
      color: #000;
    }

    .journeym-title .highlight {
      color: var(--color-primary);
    }

    /* ===== Vertical Timeline ===== */
    .timeline-containerm {
      position: relative;
      max-width: 600px;
      margin: 0 auto;
    }

    .timeline-verticalm {
      position: relative;
      list-style: none;
      margin: 0;
      padding: 0;
    }

    /* Center line */
    .timeline-verticalm::before {
      content: "";
      position: absolute;
      top: 0;
      bottom: 0;
      left: 50%;
      transform: translateX(-50%);
      width: 2px;
      background: rgba(147, 142, 250, 0.3);
    }

    /* Each step */
    .timeline-verticalm li {
      position: relative;
      margin: 60px 0;
    }

    /* Dot */
    .timeline-verticalm li::before {
      content: "";
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      width: 22px;
      height: 22px;
      background: radial-gradient(circle at 40% 35%, #6f67f7 0%, #453fe0 70%);
      border: 3px solid var(--color-primary);
      border-radius: 50%;
      box-shadow: 0 0 0 8px var(--color-bg);
      z-index: 2;
    }

    /* Text content */
    .timeline-verticalm li .content {
      position: relative;
      width: 50%;
      padding: 0 20px;
      box-sizing: border-box;
    }

    .timeline-verticalm li:nth-child(odd) .content {
      left: 50%;
      text-align: left;
    }

    .timeline-verticalm li:nth-child(even) .content {
      left: 0;
      text-align: right;
    }

    .timeline-verticalm h3 {
      font-family: 'Syne', sans-serif;
      font-size: 20px;
      color: var(--color-primary);
      margin-bottom: 8px;
    }

    .timeline-verticalm p {
      font-size: 15px;
      line-height: 1.6;
      color: #555;
    }


    /* Default — show desktop version, hide mobile */
    #journeym-desktop {
      display: block;
    }

    #journeym-mobile {
      display: none;
    }

    /* For screens below 900px (adjust breakpoint if needed) */
    @media (max-width: 900px) {
      #journeym-desktop {
        display: none;
      }

      #journeym-mobile {
        display: block;
      }
    }



    /* Default — show desktop version, hide mobile */
    #journey-desktop {
      display: block;
    }

    #journey-mobile {
      display: none;
    }

    /* For screens below 900px (adjust breakpoint if needed) */
    @media (max-width: 900px) {
      #journey-desktop {
        display: none;
      }

      #journey-mobile {
        display: block;
      }
    }



        `}</style>


    </>

  );
}

export default Aboutus;
